module.exports = __webpack_public_path__ + "Icono_Cliente-Bco_512px.png";